export const consultInitialValues = {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    description: '',
    location: '',
    //  updates: true,
    consultType: '',
};
